import { FC } from 'react';
import EmployeeLedger from '../../components/Reports/EmployeeLedger';

const EmployeeLedgerPage: FC = () => {
  return <EmployeeLedger />;
};

export default EmployeeLedgerPage;
